<script lang="ts" generics="ITEM">
    import type {SearchParams, ViewableSearch, Identified} from 'typings/portaro.be.types';
    import type {AlphabetLetter} from './types';
    import type {SearchManager} from '../search-manager/search-manager';
    import type {Observable} from 'rxjs';
    import {exists} from 'shared/utils/custom-utils';
    import {asRecordSearchParams, isRecordSearchParams} from 'shared/utils/types-utils';
    import KpSearchAlphabetsDisplay from './KpSearchAlphabetsDisplay.svelte';

    export let searchManager: SearchManager<ITEM>;

    let lastSearch: Observable<ViewableSearch<SearchParams, ITEM>>;
    $: lastSearch = searchManager.getLastSearch$();

    function getFondIds(): Identified<number>[] | null {
        if (isRecordSearchParams($lastSearch.result.params)) {
            return asRecordSearchParams($lastSearch.result.params).rootFond;
        }

        return null;
    }

    function onLetterClickHandler(letter: AlphabetLetter, diacritical: boolean) {
        searchManager.newSearchWithPartialParams({
            prefix: diacritical ? undefined : letter.value,
            diacriticalPrefix: diacritical ? letter.value : undefined
        });
    }
</script>

{#if exists($lastSearch)}
    <KpSearchAlphabetsDisplay searchFeatures="{$lastSearch.features}"
                              fonds="{getFondIds()}"
                              prefix="{$lastSearch.result.params.prefix}"
                              diacriticalPrefix="{$lastSearch.result.params.diacriticalPrefix}"
                              on:prefix-click={(event) => onLetterClickHandler(event.detail.letter, event.detail.diacritical)}/>
{/if}
